import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Input, InputProps } from './Input';

export interface FormFieldProps extends Omit<InputProps, 'error' | 'helperText'> {
  name: string;
  control?: any;
  rules?: any;
}

export const FormField: React.FC<FormFieldProps> = ({
  name,
  control,
  rules,
  ...inputProps
}) => {
  const formContext = useFormContext();
  const {
    control: contextControl,
    formState: { errors },
  } = formContext || {};

  const actualControl = control || contextControl;
  const error = errors[name];

  if (!actualControl) {
    console.warn('FormField must be used within a FormProvider or with a control prop');
    return <Input {...inputProps} error={!!error} helperText={error?.message as string} />;
  }

  return (
    <Controller
      name={name}
      control={actualControl}
      rules={rules}
      render={({ field }) => (
        <Input
          {...inputProps}
          {...field}
          error={!!error}
          helperText={error?.message as string}
        />
      )}
    />
  );
};
